/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import { Select, SelectProps } from '@mantine/core'
import FormField from '../../../../client/js/components/form/fields/FormField'

export type PriorityFieldProps = Omit<SelectProps, 'data'>

function PriorityField (props: PriorityFieldProps) {
  const { name = 'priority', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'priority',
        defaultMessage: 'Priorité'
      })}
      {...others}
      name={name}
      parser={parseNumber}
      render={Select}
      data={[
        {
          value: '-1',
          label: intl.formatMessage({
            id: 'low',
            defaultMessage: 'Basse'
          })
        },
        {
          value: '0',
          label: intl.formatMessage({
            id: 'normal',
            defaultMessage: 'Normale'
          })
        },
        {
          value: '1',
          label: intl.formatMessage({
            id: 'high',
            defaultMessage: 'Élevée'
          })
        }
      ]}
    />
  )
}

export default PriorityField
